(function () {
  if (window.__asStories) return; window.__asStories = true;
  var st = document.createElement('style');
  st.textContent = 'dialog.as-sv:not([open]){display:none!important}';
  (document.head || document.documentElement).appendChild(st);
  var dlg, fill, video, barsEl, whoEl, subEl, avaEl, ctaEl, muteEl, stage;
  var list = [], idx = 0, cfg = {}, holdTimer = null, holding = false, downX = 0, hiddenDrawer = null;
  var ICON = {
    close: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round'><path d='M18 6 6 18M6 6l12 12'/></svg>",
    prev: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'><path d='m15 18-6-6 6-6'/></svg>",
    next: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'><path d='m9 18 6-6-6-6'/></svg>",
    on: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M11 5 6 9H2v6h4l5 4z'/><path d='M15.5 8.5a5 5 0 0 1 0 7'/><path d='M19.5 5a9 9 0 0 1 0 14'/></svg>",
    off: "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M11 5 6 9H2v6h4l5 4z'/><path d='m23 9-6 6'/><path d='m17 9 6 6'/></svg>"
  };
  function build() {
    if (dlg) return;
    dlg = document.createElement('dialog');
    dlg.className = 'as-sv';
    dlg.innerHTML =
      "<button type='button' class='as-sv__arrow as-sv__arrow--prev' aria-label='Previous'>" + ICON.prev + "</button>" +
      "<div class='as-sv__stage'>" +
        "<div class='as-sv__fill'></div>" +
        "<video class='as-sv__video' playsinline webkit-playsinline preload='auto'></video>" +
        "<div class='as-sv__scrim'></div>" +
        "<div class='as-sv__bars'></div>" +
        "<div class='as-sv__top'>" +
          "<img class='as-sv__avatar' alt=''>" +
          "<div class='as-sv__meta'><span class='as-sv__who'></span><span class='as-sv__sub'></span></div>" +
          "<button type='button' class='as-sv__mute' aria-label='Toggle sound'></button>" +
          "<button type='button' class='as-sv__close' aria-label='Close'>" + ICON.close + "</button>" +
        "</div>" +
        "<div class='as-sv__cta'></div>" +
      "</div>" +
      "<button type='button' class='as-sv__arrow as-sv__arrow--next' aria-label='Next'>" + ICON.next + "</button>";
    document.body.appendChild(dlg);
    stage = dlg.querySelector('.as-sv__stage');
    fill = dlg.querySelector('.as-sv__fill');
    video = dlg.querySelector('.as-sv__video');
    barsEl = dlg.querySelector('.as-sv__bars');
    whoEl = dlg.querySelector('.as-sv__who');
    subEl = dlg.querySelector('.as-sv__sub');
    avaEl = dlg.querySelector('.as-sv__avatar');
    ctaEl = dlg.querySelector('.as-sv__cta');
    muteEl = dlg.querySelector('.as-sv__mute');
    dlg.querySelector('.as-sv__close').addEventListener('click', function (e) { e.stopPropagation(); close(); });
    dlg.querySelector('.as-sv__arrow--prev').addEventListener('click', function (e) { e.stopPropagation(); go(idx - 1); });
    dlg.querySelector('.as-sv__arrow--next').addEventListener('click', function (e) { e.stopPropagation(); go(idx + 1); });
    muteEl.addEventListener('click', function (e) { e.stopPropagation(); video.muted = !video.muted; paintMute(); });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    video.addEventListener('timeupdate', function () { if (video.duration && barsEl.children[idx]) barsEl.children[idx].firstChild.style.width = (video.currentTime / video.duration * 100) + '%'; });
    video.addEventListener('ended', function () { if (dlg.open) go(idx + 1); });
    video.addEventListener('error', function () { if (dlg.open && video.getAttribute('src')) go(idx + 1); });
    stage.addEventListener('pointerdown', onDown);
    stage.addEventListener('pointerup', onUp);
    stage.addEventListener('pointercancel', function () { clearTimeout(holdTimer); if (holding) { holding = false; barsEl.classList.remove('is-paused'); resume(); } });
    document.addEventListener('keydown', function (e) { if (!dlg.open) return; if (e.key === 'ArrowRight') go(idx + 1); else if (e.key === 'ArrowLeft') go(idx - 1); });
  }
  function cleanup() { try { video.pause(); video.removeAttribute('src'); video.load(); } catch (e) {} }
  function paintMute() { muteEl.innerHTML = video.muted ? ICON.off : ICON.on; }
  function resume() { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
  function go(n) {
    if (n < 0) { go(0); return; }
    if (n >= list.length) { close(); return; }
    idx = n;
    for (var i = 0; i < barsEl.children.length; i++) { barsEl.children[i].className = 'as-sv__bar' + (i < idx ? ' is-done' : ''); barsEl.children[i].firstChild.style.width = i < idx ? '100%' : '0'; }
    var it = list[idx];
    fill.style.backgroundImage = it.poster ? ('url(' + it.poster + ')') : 'none';
    video.src = it.video; if (it.poster) video.poster = it.poster;
    whoEl.textContent = it.name || ''; subEl.textContent = cfg.sub || 'Verified buyer';
    if (it.poster) avaEl.src = it.poster;
    var h = '';
    if (cfg.shopUrl) h += "<a class='as-sv__shop' href='" + cfg.shopUrl + "'>" + (cfg.shopLabel || 'Shop now') + "</a>";
    if (cfg.reviewsUrl) h += "<a class='as-sv__more' href='" + cfg.reviewsUrl + "'>" + (cfg.moreLabel || 'More reviews') + "</a>";
    ctaEl.innerHTML = h;
    video.muted = false; paintMute();
    var p = video.play(); if (p && p.catch) p.catch(function () { video.muted = true; paintMute(); resume(); });
  }
  function hideDrawer() {
    try {
      if (document.body.classList.contains('page-overlay-cart-on')) {
        var dr = document.querySelector('.wt-cart__drawer');
        if (dr) { dr.style.visibility = 'hidden'; hiddenDrawer = dr; }
      }
    } catch (e) {}
  }
  function restoreDrawer() {
    if (hiddenDrawer) { try { hiddenDrawer.style.visibility = ''; } catch (e) {} hiddenDrawer = null; }
  }
  function open(pl, start, c) {
    build(); list = pl; cfg = c || {};
    hideDrawer();
    barsEl.innerHTML = '';
    for (var i = 0; i < list.length; i++) { var b = document.createElement('div'); b.className = 'as-sv__bar'; b.innerHTML = '<i></i>'; barsEl.appendChild(b); }
    if (!dlg.open) { try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); } }
    go(start || 0);
  }
  function close() {
    if (dlg && dlg.open) { try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); } }
    cleanup();
    restoreDrawer();
  }
  function onDown(e) {
    if (e.target.closest('.as-sv__top') || e.target.closest('.as-sv__cta') || e.target.closest('.as-sv__arrow')) return;
    downX = e.clientX; holding = false;
    holdTimer = setTimeout(function () { holding = true; try { video.pause(); } catch (_) {} barsEl.classList.add('is-paused'); }, 300);
  }
  function onUp(e) {
    if (e.target.closest('.as-sv__top') || e.target.closest('.as-sv__cta') || e.target.closest('.as-sv__arrow')) return;
    clearTimeout(holdTimer);
    if (holding) { holding = false; barsEl.classList.remove('is-paused'); resume(); return; }
    var dx = e.clientX - downX;
    if (Math.abs(dx) > 45) { go(dx < 0 ? idx + 1 : idx - 1); return; }
    var rect = stage.getBoundingClientRect();
    var rel = (e.clientX - rect.left) / rect.width;
    if (rel < 0.34) go(idx - 1); else if (rel > 0.66) go(idx + 1);
  }
  document.addEventListener('click', function (e) {
    var s = e.target.closest ? e.target.closest('.as-story') : null;
    if (!s) return;
    e.preventDefault();
    var strip = s.closest('.as-stories');
    var els = strip ? strip.querySelectorAll('.as-story') : [s];
    var pl = [];
    for (var i = 0; i < els.length; i++) pl.push({ video: els[i].getAttribute('data-video'), poster: els[i].getAttribute('data-poster'), name: els[i].getAttribute('data-name') });
    var start = 0; for (var j = 0; j < els.length; j++) { if (els[j] === s) { start = j; break; } }
    var c = strip ? { shopUrl: strip.getAttribute('data-shop-url'), reviewsUrl: strip.getAttribute('data-reviews-url'), shopLabel: strip.getAttribute('data-shop-label'), moreLabel: strip.getAttribute('data-more-label'), sub: strip.getAttribute('data-sub') } : {};
    open(pl, start, c);
  });
})();
